import { Inject, Injectable } from '@angular/core';
import {
  VariationModel,
  StorePageStore,
  STORE_SERVICE,
  IStoreService,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromVariationsActions from './store-variations.actions';

@Injectable()
export class StoreVariationsEffects {
  loadVariations$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromVariationsActions.loadVariationsBeginAction),
      switchMap(() =>
        this.service.loadProductsVariations().pipe(
          mergeMap((data) => [
            fromVariationsActions.loadVariationsSuccessAction({
              payload: data,
            }),
            fromVariationsActions.clearVariationsSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadVariations$ ERROR', errors);
            return of([
              fromVariationsActions.loadVariationsFailAction({ errors }),
              fromVariationsActions.clearVariationsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  loadVariationById$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromVariationsActions.loadVariationByIdBeginAction),
      switchMap((action: any) =>
        this.service.loadProductVariationById(action.id).pipe(
          mergeMap((payload) => [
            fromVariationsActions.loadVariationByIdSuccessAction({ payload }),
            fromVariationsActions.clearVariationsSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadVariationById$ ERROR', errors);
            return of([
              fromVariationsActions.loadVariationByIdFailAction({ errors }),
              fromVariationsActions.clearVariationsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  // createVariation$ = createEffect(() =>
  //   this.actions.pipe(
  //     ofType(fromVariationsActions.creteVariationBeginAction),
  //     withLatestFrom(this.storePageStore.variationsStore.data$),
  //     switchMap(([action, variationsData]) =>
  //       this.service.createProductVariation(action.payload).pipe(
  //         mergeMap((data) => {
  //           const payload = [data, ...variationsData];
  //           return [
  //             fromVariationsActions.creteVariationSuccessAction({ payload }),
  //             fromVariationsActions.clearVariationsSuccessErrorDataAction(),
  //           ];
  //         }),
  //         catchError((errors) => {
  //           console.error('StoreEffects.createVariation$ ERROR', errors);
  //           return of([
  //             fromVariationsActions.creteVariataionFailAction({ errors }),
  //             fromVariationsActions.clearVariationsSuccessErrorDataAction(),
  //           ]).pipe(switchMap((d) => d));
  //         })
  //       )
  //     )
  //   )
  // );

  // deleteVariation$ = createEffect(() =>
  //   this.actions.pipe(
  //     ofType(fromVariationsActions.delteVariationBeginAction),
  //     withLatestFrom(this.storePageStore.variationsStore.data$),
  //     switchMap(([action, variationsData]: [any, VariationModel[]]) =>
  //       this.service.deleteProductVariation(action.id).pipe(
  //         mergeMap(() => {
  //           const payload = variationsData.filter((v) => v.id !== action.id);
  //           return [
  //             fromVariationsActions.delteVariationSuccessAction({ payload }),
  //             fromVariationsActions.clearVariationsSuccessErrorDataAction(),
  //           ];
  //         }),
  //         catchError((errors) => {
  //           console.error('StoreEffects.deleteVariation$ ERROR', errors);
  //           return of([
  //             fromVariationsActions.delteVariationFailAction({ errors }),
  //             fromVariationsActions.clearVariationsSuccessErrorDataAction(),
  //           ]).pipe(switchMap((d) => d));
  //         })
  //       )
  //     )
  //   )
  // );

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
